export default {
	UPLOADS: 'companies/:company_id/uploads/',
	UPLOADS_GET_LEASE: 'companies/:company_id/uploads/get-lease/',
	// UPLOADS_GET_LEASE_UPLOADS: 'uploads/get-lease-uploads/'
}
